import React from 'react';
import Compiler from '../../Component/files/Compiler';
import DefaultTemplate from '../../Component/files/DefaultTemplate';
import PythonTestCases from './PythonTestCases';

const CodingForm = ({
  selectedQuestion,
  setSelectedQuestion,
  defaultTemplate,
  setdefaultTemplate,
  code1,
  setCode1,
  code2,
  setCode2,
  examples,
  setExamples,
  keywords,
  setKeywords,
  tags,
  settags,
  explain,
  setExplain,
  hints,
  setHints,
  testCases,
  setTestCases,
  refreshKey,
  handleExampleValueChange,
  handleExampleOutputChange,
  handleExampleExplanationChange,
  addExampleValue,
  removeExampleValue,
  addExample,
  removeExample,
  handleTestCaseValueChange,
  handleTestCaseOutputChange,
  addTestCaseValue,
  removeTestCaseValue,
  addTestCase,
  removeTestCase,
  handleKeywordChange,
  addKeyword,
  handletagChange,
  addtag,
  addExplanation,
  handleExplainChange,
  addHint,
  handleHintChange
}) => {
  return (
    <div className="row">
      <div className="col-lg-6">
        <div className="mb-4">
          <h5 className="text-muted ">Question:</h5>
          <textarea
            id="que"
            rows="4"
            required={true}
            placeholder="Enter Question here....."
            className="form-control custom-input"
            value={selectedQuestion}
            onChange={(e) => setSelectedQuestion(e.target.value)}
          ></textarea>
        </div>
        <DefaultTemplate
          key={refreshKey}
          defaultTemplate={defaultTemplate}
          setdefaultTemplate={setdefaultTemplate}
        />
        <div className="mb-4">
          <h5 className="text-muted">Examples:</h5>
          {examples.map((example, exampleIndex) => (
            <div
              key={exampleIndex}
              className="example mt-3 position-relative"
            >
              <button
                className="btn-close bg-danger position-absolute top-0 end-0"
                aria-label="Close"
                onClick={() => removeExample(exampleIndex)}
              />
              <div className="form-group">
                <p>
                  Enter Example {exampleIndex + 1} values,
                  output, and explanation:
                </p>
                <label>Values:</label>
                {example.Inputs.map((value, valueIndex) => (
                  <div
                    key={valueIndex}
                    className="mb-2 position-relative"
                  >
                    <input
                      type="text"
                      className="form-control custom-input"
                      value={value}
                      onChange={(e) =>
                        handleExampleValueChange(
                          exampleIndex,
                          valueIndex,
                          e.target.value
                        )
                      }
                      placeholder={`Enter value ${valueIndex + 1}`}
                    />
                    {example.Inputs.length > 1 && (
                      <button
                        className="btn-close position-absolute top-0 end-0"
                        aria-label="Close"
                        onClick={() =>
                          removeExampleValue(
                            exampleIndex,
                            valueIndex
                          )
                        }
                      />
                    )}
                  </div>
                ))}
                <button
                  className="btn text-light btn-sm mt-1"
                  style={{ backgroundColor: "#377383" }}
                  onClick={() => addExampleValue(exampleIndex)}
                >
                  Add Value
                </button>
              </div>
              <div className="form-group">
                <label>Output:</label>
                <textarea
                  rows="1"
                  className="form-control custom-input"
                  value={example.Output}
                  onChange={(e) =>
                    handleExampleOutputChange(
                      exampleIndex,
                      e.target.value
                    )
                  }
                  placeholder="Enter output"
                />
              </div>
              <div className="form-group">
                <label>Explanation:</label>
                <textarea
                  rows="2"
                  className="form-control custom-input"
                  value={example.Explanation}
                  onChange={(e) =>
                    handleExampleExplanationChange(
                      exampleIndex,
                      e.target.value
                    )
                  }
                  placeholder="Enter explanation"
                />
              </div>
            </div>
          ))}
          <button
            className="btn text-light btn-sm mt-1"
            style={{ backgroundColor: "#377383" }}
            onClick={addExample}
          >
            Add Example
          </button>
        </div>
        <div className="mb-4">
          <h5 className="text-muted">Keywords:</h5>
          {keywords.map((keyword, index) => (
            <div key={index} className="mb-3 position-relative">
              <div className="form-group">
                <label htmlFor={`keyword${index}`}>
                  Keyword {index + 1}:
                </label>
                <input
                  type="text"
                  id={`keyword${index}`}
                  className="form-control custom-input mb-2"
                  value={keyword}
                  onChange={(e) =>
                    handleKeywordChange(index, e.target.value)
                  }
                  placeholder="Enter keyword"
                />
                <button
                  className="btn-close position-absolute top-0 end-0"
                  aria-label="Close"
                  onClick={() => {
                    setKeywords((prevKeywords) =>
                      prevKeywords.filter((_, i) => i !== index)
                    );
                  }}
                />
              </div>
            </div>
          ))}
          <button
            className="btn text-light btn-sm mt-1"
            style={{ backgroundColor: "#377383" }}
            onClick={addKeyword}
          >
            Add Keyword
          </button>
        </div>

        <div className="mb-4">
          <h5 className="text-muted">Explanation:</h5>
          {explain.map((explanation, index) => (
            <div key={index} className="mb-3 position-relative">
              <div className="form-group">
                <label htmlFor={`explanation${index}`}>
                  Explanation {index + 1}:
                </label>
                <textarea
                  rows="2"
                  className="form-control custom-input mb-2"
                  value={explanation}
                  onChange={(e) =>
                    handleExplainChange(index, e.target.value)
                  }
                  placeholder="Enter explanation"
                />
                <button
                  className="btn-close position-absolute top-0 mt-1 end-0"
                  aria-label="Close"
                  onClick={() => {
                    setExplain((prevExplain) =>
                      prevExplain.filter((_, i) => i !== index)
                    );
                  }}
                />
              </div>
            </div>
          ))}
          <button
            className="btn text-light mt-1 btn-sm"
            style={{ backgroundColor: "#377383" }}
            onClick={addExplanation}
          >
            Add Explanation
          </button>
        </div>
        <div className="mb-4">
          <h5 className="text-muted">Hints:</h5>
          {hints.map((hint, index) => (
            <div key={index} className="mb-3 position-relative">
              <div className="form-group">
                <label htmlFor={`hint${index}`}>
                  Hint {index + 1}:
                </label>
                <input
                  type="text"
                  id={`hint${index}`}
                  className="form-control custom-input mb-2"
                  value={hint}
                  onChange={(e) =>
                    handleHintChange(index, e.target.value)
                  }
                  placeholder="Enter Hint"
                />
                <button
                  className="btn-close position-absolute top-0 end-0"
                  aria-label="Close"
                  onClick={() => {
                    setHints((prevHints) =>
                      prevHints.filter((_, i) => i !== index)
                    );
                  }}
                />
              </div>
            </div>
          ))}
          <button
            className="btn text-light btn-sm mt-1"
            style={{ backgroundColor: "#377383" }}
            onClick={addHint}
          >
            Add Hint
          </button>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="">
          <Compiler
            key={refreshKey}
            code1={code1}
            setCode1={setCode1}
            code2={code2}
            setCode2={setCode2}
          />
          <div className="mb-4">
            <h5 className="text-muted">Enter Tags :</h5>
            {tags.map((tag, index) => (
              <div
                key={index}
                className="mb-3 position-relative"
              >
                <div className="form-group">
                  <label htmlFor={`tag${index}`}>
                    Tag {index + 1}:
                  </label>
                  <input
                    type="text"
                    id={`tag${index}`}
                    className="form-control custom-input mb-2"
                    value={tag}
                    onChange={(e) =>
                      handletagChange(index, e.target.value)
                    }
                    placeholder="Enter tag"
                  />
                  <button
                    className="btn-close position-absolute top-0 end-0"
                    aria-label="Close"
                    onClick={() => {
                      settags((prevtags) =>
                        prevtags.filter((_, i) => i !== index)
                      );
                    }}
                  />
                </div>
              </div>
            ))}
            <button
              className="btn text-light btn-sm mt-1"
              style={{ backgroundColor: "#377383" }}
              onClick={addtag}
            >
              Add tag
            </button>
          </div>
          <PythonTestCases
            testCases={testCases}
            handleTestCaseValueChange={handleTestCaseValueChange}
            handleTestCaseOutputChange={handleTestCaseOutputChange}
            addTestCaseValue={addTestCaseValue}
            removeTestCaseValue={removeTestCaseValue}
            addTestCase={addTestCase}
            removeTestCase={removeTestCase}
          />
        </div>
      </div>
    </div>
  );
};

export default CodingForm; 